import React, { useState, useEffect, useRef } from 'react';
import { Box, Card, Skeleton, Typography, CircularProgress, Icon, IconButton, Tooltip, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Other_Doctor_Notes_Layout_JSON } from '../../../../Utility/Constants';
import { ActionButton, RenderTextBox, RenderChip, RenderTable, RenderIcdDiagnosis, renderNOData, RenderVitals, RenderObstericData } from "./SarasCommonComp";
import SarasBoldItalic from './SarasBoldItalic';
import SarasPrescription from './SarasPrescription';
import SarasPainScale from './SarasPainScale';
import SarasPatientCategory from './SarasPatientCategory';
import SarasReviewPlan from './SarasReviewPlan';
import SarasIcdDiagnosis from './SarasIcdDiagnosis';
import SarasClinicExamination from './SarasClinicExamination';
// import SarasCounselling from './SarasCounselling';
import './SarasDocNotes.css';
import SarasTest from './SarasTest';
import SarasVitals from './SarasVitals';
import SarasPatientHeader from './SarasPatientHeader';
import SarasExamination from './SarasExamination';
import SarasObstericData from './SarasObstericData';
import SarasAllergies from './SarasAllergies';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const getButtonStyle = (isSelected) => ({
    width: "100%",
    color: isSelected ? '#fff' : Colors.SecondaryText,
    borderTop: isSelected ? '1px solid transparent' : 'none',
    borderBottom: isSelected ? '1px solid transparent' : '1px solid #E3E2E2',
    borderRadius: 0,
    textAlign: 'left',
    justifyContent: 'flex-start',
});

const keyMapping = {
    plan: 'plans',
    pain_scale: 'pain_chart',
    allergies: 'allergy',
};

const SarasDocNotesHome = () => {
    const prescriptionRef = useRef();
    const [state, setState] = useState({
        PatientData: {},
        isLocked: false,
        TransferDisable: false,
        loginInfo: null,
        povList: [],
        DocNotesLayout: [],
        SelectedComponent: null,
        layoutloading: false,
        scrollToIndex: null,
        dynamicState: {},
        hasFetched: null,

        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
        clinicId: localGetItem("SelectedDoctorClinicId"),
        visitLoading: false,
        lastVisitRecord: {},
        TransmitDisable: false,
        alleryData: [],
        AIGeneratedTextData: [],
        AIDocNotesKeys: null,
        FetchedAIMedication: [],
        tempLoad: false,
    });
    const divRefs = useRef([]);

    useEffect(() => {
        const patientData = JSON.parse(getCachevalue("DoctorPatientData"));
        const myUser = JSON.parse(localGetItem("loggedInUserInfo"));
        const POVList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit")
        const povArr = JSON.parse(POVList).reduce((acc, { reason }) => [...acc, reason], []);

        updateState({
            PatientData: patientData,
            appointmentId: patientData?.appointment_id,
            patientId: patientData?.patient_id,
            isLocked:getCachevalue('DoctorUserChanged') === 'true' ? true : patientData?.transfer_appointment ? patientData?.transfer_appointment : patientData?.is_locked,
            TransferDisable: patientData?.is_transmitted ? patientData?.is_transmitted : false,
            loginInfo: myUser,
            povList: povArr,
        })
    }, []);

    useEffect(() => {
        if (state.loginInfo) {
            getDoctorNotesLayout()
            getLastVisitRecords()
            if(localGetItem("enable_ai_doctor_notes") === "true"){
                getAIDoctorNotesMsg()
            }
        }
    }, [state.loginInfo])

    useEffect(() => {
        if (state.appointmentId) {
            getNewLayoutData()
        }
    }, [state.appointmentId])

    useEffect(() => {
    if (state.DocNotesLayout.length) {
        const newRefs = [];
        let activeIndex = 0;

        for (let i = 0; i < state.DocNotesLayout.length; i++) {
            if (state.DocNotesLayout[i].is_active) {
                newRefs[activeIndex] = divRefs.current[activeIndex] ?? React.createRef();
                activeIndex++;
            }
        }

        divRefs.current = newRefs;
    }
}, [state.DocNotesLayout]);

    useEffect(() => {
        if (!state.layoutloading && state.DocNotesLayout.length > 0) {
            // Find first active item index
            const firstActiveIndex = state.DocNotesLayout.findIndex(item => item.is_active);
            setState(prev => ({
                ...prev,
                scrollToIndex: firstActiveIndex === -1 ? null : 0, // 0 for first active item in refs
                SelectedComponent: state.DocNotesLayout[firstActiveIndex]?.field_name,
            }));
        }
    }, [state.layoutloading, state.DocNotesLayout]);

    useEffect(() => {
        if (
            state.scrollToIndex !== null &&
            !state.layoutloading &&
           divRefs.current[state.scrollToIndex]?.current
        ) {
            requestAnimationFrame(() => {
                divRefs.current[state.scrollToIndex].current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center',
                });
            });
        }
    }, [state.scrollToIndex, state.layoutloading, state.DocNotesLayout]);


    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const clearFetchedAIMedication = () => {
        updateState({ FetchedAIMedication: [] })
    }

    const handleDisableTransfer = (flag) => {
        updateState({ TransmitDisable: flag })
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }
    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }
    const AIGeneratedText = (data) => {
        updateState({
            AIGeneratedTextData : data
        })
        getAIDoctorNotesMsg()
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    // get apis start
    const getDoctorNotesLayout = () => {
        try {
            updateState({ layoutloading: true })
            const Doctor_Notes_Layout = JSON.parse(JSON.stringify(Other_Doctor_Notes_Layout_JSON));
            if (state?.loginInfo?.service_type === "ENT") {
                Doctor_Notes_Layout?.push(
                    { id: Doctor_Notes_Layout?.length + 1, field_name: 'clinicExam', label: 'Clinical Examination', is_active: true }
                )
            }
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const { field_data } = response.data.data;
                        const layoutData = field_data?.left_data
                            ? field_data?.left_data.filter(item => !(state.isNewBilling && item.field_name === 'counselling'))
                            : Doctor_Notes_Layout
                        updateState({
                            DocNotesLayout: layoutData,
                            SelectedComponent: layoutData[0]?.field_name,
                            isNewLayout: layoutData[0]?.is_new ? layoutData[0] : {},
                            layoutloading: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ layoutloading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ layoutloading: false })
            errorMessage(error.message)
        }
    }

    const getAIDoctorNotesMsg = () => {
        try {
            RestAPIService.getAll(Serviceurls.AI_DOCTOR_NOTES_DETAILS + `?clinic_id=${state.clinicId}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            AIDocNotesKeys : response.data || null,
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getLastVisitRecords = () => {
        try {
            updateState({ visitLoading: true })
            RestAPIService.getAll(Serviceurls.SARAS_DOC_LAST_VISIT_RECORDS + `?appointment_id=${state.PatientData?.appointment_id}&patient_id=${state.PatientData?.patient_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            lastVisitRecord: response.data.data,
                            visitLoading: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ visitLoading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ visitLoading: false })
            errorMessage(error.message)
        }
    }

    const generateStatekey = (value) => {
        return value?.toLowerCase()?.replace(/\s+/g, "_")
    }

    const getNewLayoutData = (forceFetch = "") => {
        try {
            if (forceFetch && state.hasFetched === forceFetch) return;
            RestAPIService.getAll(Serviceurls.SARAS_DOC_NEW_LAYOUT + '?patient_id=' + state.patientId + '&appointment_id=' + state.appointmentId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const dynamicState = Object.entries(response.data.data).reduce((acc, [key, value]) => {
                            const stateKey = generateStatekey(key);
                            acc[stateKey] = value.comments || "";
                            return acc;
                        }, {});
                        updateState({
                            dynamicState: dynamicState || {},
                            hasFetched: forceFetch,
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const fetchAIMedication = (MediData = []) => {
        try {
            let data = {
                clinic_id: state.clinicId,
                template_data: MediData,
                time : new Date().toISOString()
            }
            RestAPIService.create(data, Serviceurls.AI_DOCTOR_NOTES_MEDICATION)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            FetchedAIMedication: response.data.data || [],
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    // get apis end

    const renderMenu = () => {
         let activeIndex = 0;
        return (
            <Box width={"100%"} height={"100%"} display={"flex"} flexDirection={"column"} alignItems={"flex-start"}>
                <ActionButton
                    text={"Menu"}
                    emed_tid='doc_notes_moveto_option'
                    className='emed_menuItem'
                    variant={'text'}
                    sx={{
                        ...getButtonStyle(false),
                        fontWeight: "bold",
                        borderBottom: "none"
                    }}
                />
                {
                    state.layoutloading ? (
                        <Box sx={{ width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress color="primary" size={"1vw"} />
                        </Box>
                    ) : (state.DocNotesLayout?.length > 0 ? (state.DocNotesLayout?.map((item, index) => {
                        const isSelected = state.SelectedComponent === item.field_name;
                        const isExcluded = ['past_history', 'clinical_history'].includes(item.field_name);
                        if (!item?.is_active || isExcluded) return null;
                        const currentActiveIndex = activeIndex;
                        activeIndex++;
                        return (
                            <ActionButton
                                key={index}
                                text={item.custom_name}
                                emed_tid='doc_notes_moveto_option'
                                className='emed_menuItem'
                                variant={isSelected ? 'contained' : 'text'}
                                sx={getButtonStyle(isSelected)}
                                onClick={() => {
                                    updateState({
                                        SelectedComponent: item.field_name,
                                        isNewLayout: item.is_new ? item : {},
                                        scrollToIndex: currentActiveIndex
                                    })
                                }}
                            />
                        )
                    })): renderNOData())
                }
            </Box>
        )
    }

    const setAllergyData = (data) => {
        updateState({ alleryData: data || [] })
    }

    const getPrescriptionTemplate = () => {
        prescriptionRef.current?.getPrescriptionListData();
    }

    const renderComponent = (data) => {
        const { field_name, custom_name, is_new, label } = data;
        const commonProps = {
            Title: custom_name,
            field_name,
            PatientData: state.PatientData,
            patientId: state.patientId,
            appointmentId: state.appointmentId,
            isSelected: field_name === state.SelectedComponent,
            isLocked: state.isLocked,
            isCompleted: PatientData?.appointment_status === "Completed",
            errorMessage: errorMessage.bind(this),
            successMessage: successMessage.bind(this),
            clinicId: state.clinicId
        };

        switch (field_name) {
            case "prescription":
                return <SarasPrescription {...commonProps}
                    ref={prescriptionRef}
                    FetchedAIMedication={state.FetchedAIMedication}
                    clearFetchedAIMedication={clearFetchedAIMedication.bind(this)}
                    handleDisableTransfer={handleDisableTransfer.bind(this)} />;
            case "pain_scale":
                return <SarasPainScale {...commonProps} />;
            case "vitals":
                return <SarasVitals {...commonProps} />;
            case "patient_category":
                return <SarasPatientCategory {...commonProps} />;
            case "test":
                return <SarasTest {...commonProps} />;
            case "counselling":
                return null;
            // return <SarasCounselling {...commonProps}
            //     handleDisableTransfer={handleDisableTransfer.bind(this)} />;
            case "review_plan":
                return <SarasReviewPlan {...commonProps} />;
            case "clinicExam":
                return <SarasClinicExamination {...commonProps} />;
            case "diagnosis":
                return <SarasIcdDiagnosis {...commonProps} systemName={label} />;
            case "examination":
                return <SarasExamination {...commonProps} />;
            case "obstetric_data":
                return <SarasObstericData {...commonProps} />;
            case "allergies":
                return <SarasAllergies
                    {...commonProps}
                    showAllergyData={setAllergyData.bind(this)}
                    PrescriptonTemplate={getPrescriptionTemplate.bind(this)}
                    allergyData={state.alleryData || []} />;
            case "clinical_history":
            case "past_history":
                return null;
            default:
                return <SarasBoldItalic
                    {...commonProps}
                    stateValue={state.dynamicState[field_name] || ""}
                    GetAPiCall={(data) => getNewLayoutData(data)}
                    systemName={label}
                    setAllergyData={setAllergyData.bind(this)}
                    isNewLayout={Boolean(is_new)}
                />
        }
    }

    const renderVisitRecords = () => {
        return (
            <Box width="100%" height="100%">
                <Typography fontSize={"0.85vw"} fontWeight={"bold"} padding={"0.5dvw"} borderBottom={`1px solid #E3E2E2`} color={Colors.SecondaryText}>Last Visit Records</Typography>
                {(state.layoutloading || state.visitLoading) ? (
                    <Box sx={{ width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress color="primary" size={"1vw"} />
                    </Box>
                ) :
                    (Object.keys(state.lastVisitRecord)?.length > 0 ?
                        state.DocNotesLayout?.map((item, index) => {
                            if (!item.is_active) return null;
                            const isSelected = state.SelectedComponent === item.field_name;

                            const hasIcd = state.lastVisitRecord.icd_diagnosis && state.lastVisitRecord.icd_diagnosis.length > 0;
                            const hasProvisional = state.lastVisitRecord.provisional_diagnosis;

                            const fieldKey = item.field_name?.toLowerCase();
                            const actualKey = keyMapping[fieldKey] || fieldKey;

                            const value = item.is_new ? state.lastVisitRecord[item.custom_name] : state.lastVisitRecord[actualKey];
                            if (!value || (Array.isArray(value) && value.length === 0)) return null;

                            switch (fieldKey) {
                            case 'Complaints':
                            case 'plan':
                            case 'general_advice':
                            case 'final_diagnosis':
                            case 'symptoms':
                                return (
                                    <RenderTextBox
                                        isSelected={isSelected}
                                        field_name={item.field_name}
                                        key={index}
                                        label={item.custom_name}
                                        content={value}
                                    />
                                )
                            case 'clinical_history':
                            case 'past_history':
                                return null;
                            case 'patient_category':
                                return (
                                    <RenderChip
                                        key={index}
                                        isSelected={isSelected}
                                        field_name={item.field_name}
                                        label={item.custom_name}
                                        list={value}
                                    />
                                );

                            case 'review_plan':
                                return (
                                    <RenderTable
                                        key={index}
                                        isSelected={isSelected}
                                        field_name={item.field_name}
                                        tblLabel={item.custom_name}
                                        tblData={[value]}
                                    />
                                );
                            case 'prescription':
                            case 'test':
                            case 'pain_scale':
                            case 'examination':
                            case "allergies":
                                return (
                                    <RenderTable
                                        key={index}
                                        isSelected={isSelected}
                                        field_name={item.field_name}
                                        tblLabel={item.custom_name}
                                        tblData={value}
                                    />
                                );
                            case 'vitals':
                                return(
                                    <RenderVitals
                                        isSelected={isSelected}
                                        field_name={item.field_name}
                                        key={index}
                                        label={item.custom_name}
                                        valueobj={value} />
                                )
                            case 'diagnosis':
                                return (
                                    <React.Fragment key={index}>
                                        {hasIcd && (
                                            <RenderIcdDiagnosis
                                                label={item.custom_name}
                                                isSelected={isSelected}
                                                field_name={item.field_name}
                                                list={state.lastVisitRecord.icd_diagnosis}
                                            />
                                        )}
                                        {hasProvisional && (
                                            <RenderTextBox
                                                label="Provisional Diagnosis"
                                                isSelected={isSelected}
                                                field_name={item.field_name}
                                                content={state.lastVisitRecord.provisional_diagnosis}
                                            />
                                        )}
                                    </React.Fragment>
                                );
                            case 'obstetric_data':
                                return <RenderObstericData
                                    isSelected={isSelected}
                                    field_name={item.field_name}
                                    key={index}
                                    label={item.custom_name}
                                    valueobj={value} />
                            default:
                                if (item.is_new) {
                                    return (
                                        <RenderTextBox
                                            key={index}
                                            isSelected={isSelected}
                                            field_name={item.field_name}
                                            label={item.label}
                                            content={value}
                                        />
                                    );
                                }
                                return null;
                        }
                        }) : renderNOData())}
            </Box>
        )
    }
    const AIDoctorNotes = () => {
        return (
            <Box width="100%" height="100%">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography fontSize={"0.85vw"} fontWeight={"bold"} padding={"0.5dvw"} borderBottom={`1px solid #E3E2E2`} color={Colors.SecondaryText}>
                        AI Generated Doctor Notes
                    </Typography>
                    <Button sx={{ textTransform: "capitalize" }} size='small' variant='outlined' onClick={() => {
                        updateState({
                            AIGeneratedTextData: []
                        })
                    }}>Close</Button>
                </Box>
                {state.AIGeneratedTextData?.length > 0 ? (
                    <Box sx={{ padding: '0.5dvw', display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {state.AIGeneratedTextData.map((item, index) => (
                            <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" fontWeight="bold">
                                        {item.key.replace(/_/g, ' ')}
                                    </Typography>
                                    <Tooltip title={item.key === "Medications" ? "Fetch Medication" : "Copy text"} arrow placement="top">
                                        <IconButton
                                            size="small"
                                            sx={{ marginLeft: '0.5vw' }}
                                            onClick={() => {
                                                if(item.key === "Medications"){
                                                    if(typeof(item?.data) === "object"){
                                                        fetchAIMedication(Array.isArray(item.data) ? item.data : [item.data]);
                                                    }else{
                                                        errorMessage("No medication data available to copy");
                                                    }
                                                }else{
                                                    navigator.clipboard.writeText(item.data || "");
                                                }
                                            }}
                                        >
                                            <ContentCopyIcon fontSize="small" color='primary' />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                {item.key === "Medications" ? (
                                    <Box sx={{ overflow: 'auto' }}>
                                        <Table size="small" sx={{ minWidth: 300 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Brand Name</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Dosage Strength</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Instructions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Array.isArray(item.data) ? (
                                                    item.data.map((med, medIndex) => (
                                                        <TableRow key={medIndex}>
                                                            <TableCell>{med.brand_name}</TableCell>
                                                            <TableCell>{med.dosage_strength}</TableCell>
                                                            <TableCell>{med.quantity}</TableCell>
                                                            <TableCell>{med.instructions}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : item.data ? (
                                                    <TableRow>
                                                        <TableCell>{item.data.brand_name}</TableCell>
                                                        <TableCell>{item.data.dosage_strength}</TableCell>
                                                        <TableCell>{item.data.quantity}</TableCell>
                                                        <TableCell>{item.data.instructions}</TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={4} sx={{ textAlign: 'center' }}>No medication data available</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                ) : (
                                    <Typography variant="body2">
                                        {typeof item.data === 'object' ? JSON.stringify(item.data, null, 2) : item.data || "No data available"}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                    </Box>
                ) : null}
            </Box>
        )
    }
    const istemplate = (status) => {
        updateState({
            tempLoad: status,
            layoutloading: status
        });
    };
    // render content
    const { PatientData, isLocked } = state;

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "100%" }}>
            {/* Patient header */}
            <SarasPatientHeader
                PatientData={PatientData}
                TransmitDisable={state.TransmitDisable}
                isLocked={isLocked}
                alleryData={state.alleryData || []}
                AIGeneratedText={AIGeneratedText.bind(this)}
                errorMessage={errorMessage.bind(this)}
                successMessage={successMessage.bind(this)}
                AIDocNotesKeys={state.AIDocNotesKeys}
                istemplate={istemplate.bind(this)}
            />
            {/* Content div */}
            <Box className="emed_grid_container">
                <Card sx={{ overflowY: 'auto', padding: '0.625dvw' }}>{renderMenu()}</Card>
                <Box className="emed_grid_column" sx={{ padding: "0px", border: state.layoutloading ? "1px solid #ccc" : " none" }}>
                    {state.layoutloading ? (
                        <Box>
                            {[25, 25, 10].map((h, i) => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    animation="wave"
                                    width="97%"
                                    height={`${h}vh`}
                                    sx={{ margin: '1vw' }}
                                />
                            ))}
                        </Box>
                    ) : (
                       state.tempLoad ? <Box></Box> : state.DocNotesLayout?.length > 0 ?
                            state?.DocNotesLayout?.reduce((acc, item, index) => {
                                if (!item.is_active) return acc;
                                const activeIndex = acc.length; // the number of active items so far

                                acc.push(
                                    <Box
                                        key={item.id || index}
                                        ref={divRefs.current[activeIndex]}
                                        onClick={() =>
                                            updateState({
                                                SelectedComponent: item.field_name,
                                                isNewLayout: item?.is_new ? item : {},
                                            })
                                        }
                                    >
                                        {renderComponent(item)}
                                    </Box>
                                );
                                return acc;
                            }, []) : renderNOData()
                    )}
                </Box>
                <Card sx={{ overflowY: 'auto', padding: '0.625dvw' }}>{state?.AIGeneratedTextData?.length ? AIDoctorNotes() : renderVisitRecords()}</Card>
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}

export default SarasDocNotesHome;